<template>
  <div v-if="visible" class="modal">
    <input v-model="localValue" placeholder="在模态框中输入">
    <button @click="handleConfirm">确认</button>
  </div>
</template>
<script>
export default {
  props: ['visible', 'initialValue'],
  data() {
    return { localValue: this.initialValue };
  },
  methods: {
    handleConfirm() {
      this.$emit('update:value', this.localValue); // 更新父组件值
      this.$emit('close'); // 关闭模态框
    }
  }
};
</script>